import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {css} from "@panda/css";

import {ChevronDownIcon, ChevronUpIcon, WalkIcon} from "@pg-design/icons-module";
import {Switcher} from "@pg-design/switcher-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../app/rp_reducer";
import {setActivePoiDirections} from "../actions/set_poi_travel_directions";
import {poiAnalytics, PoiGTMModalAction} from "../tracking/poi_analytics";
import {PoiType} from "../types/PoiType";
import {SWITCHER_POI_CONFIG} from "../utils/poi_type_utils";
import {PoiSwitcherDistance} from "./PoiSwitcherDistance";

const WALK_SPEED_KM_PER_HOUR = 4;
const getWalkMinutesForDistance = (distanceKm: number) => Math.round((distanceKm / WALK_SPEED_KM_PER_HOUR) * 60);

interface IProps {
    checkedPoiTypes: PoiType[];
    onChange: (checkedPoiTypes: PoiType[]) => void;
    distanceValue?: number;
    onDistanceChange?: (value: number) => void;
    hideHeader?: boolean;
    disableCollapsible?: boolean;
    className?: string;
}

export const PoiSwitcher = (props: IProps) => {
    const dispatch = useDispatch();
    const params = useParams<{offerId?: string; propertyId?: string}>();

    const [collapsed, setCollapsed] = useState(false);

    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    const togglePoiType = (type: string, checked: boolean) => {
        /*
         * Because our current implementation of rendering markers on the map re-renders marker each time when we are
         * adding or removing records (markers) (so marker InfoWindow is being closed) we need to remove polylines from the map.
         */
        dispatch(setActivePoiDirections(null));

        props.onChange(checked ? props.checkedPoiTypes.concat(type as PoiType) : props.checkedPoiTypes.filter((item) => item !== type));

        poiAnalytics.gtm.mapEvent({
            action: checked ? PoiGTMModalAction.IMPORTANT_PLACES_ON : PoiGTMModalAction.IMPORTANT_PLACES_OFF,
            label: normalizePoiTypeForAnalytics(type)
        });
        poiAnalytics.algolytics.showPoi(viewType, checked, type as PoiType, params.offerId, params.propertyId);
    };

    return (
        <div className={props.className}>
            {props.hideHeader ? null : (
                <div className={headingStyle}>
                    <Text as="p" variant="mini_header">
                        Ważne miejsca
                    </Text>
                    {props.disableCollapsible ? null : (
                        <span className={toggleIconStyle} onClick={() => setCollapsed((prev) => !prev)}>
                            {collapsed ? <ChevronDownIcon size="2" /> : <ChevronUpIcon size="2" />}
                        </span>
                    )}
                </div>
            )}

            {(!collapsed || props.disableCollapsible) && (
                <>
                    {typeof props.distanceValue === "number" && (
                        <div className={walkTimeRowStyle}>
                            <WalkIcon size="1.6" fill="var(--colors-gray-700)" />
                            <Text variant="info_txt_2" as="p" color="var(--colors-gray-700)">
                                W promieniu {getWalkMinutesForDistance(props.distanceValue)} min pieszo
                            </Text>
                        </div>
                    )}

                    <div>
                        {SWITCHER_POI_CONFIG.map((poiType) => {
                            const checked = props.checkedPoiTypes.includes(poiType.type);
                            const Icon = poiType.icon;

                            return (
                                <div key={poiType.type} className={poiTypeItemStyle}>
                                    <div className={poiTypeLabelStyle}>
                                        <Icon size="1.6" wrapperSize="2.4" wrapperColor={poiType.color} wrapperType="circle" />
                                        <Text variant="info_txt_1" as="span">
                                            {poiType.label}
                                        </Text>
                                    </div>

                                    <Switcher
                                        id={poiType.type}
                                        checked={checked}
                                        onChange={(checked) => togglePoiType(poiType.type, checked)}
                                        labelContent=""
                                        checkedColor="var(--colors-gray-800)"
                                    />
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            {props.onDistanceChange ? (
                <div className={poiDistanceWrapperStyle}>
                    <Text variant="mini_header" mb={1} as="p">
                        Promień
                    </Text>
                    <PoiSwitcherDistance value={props.distanceValue} onChange={props.onDistanceChange} />
                </div>
            ) : null}
        </div>
    );
};

const normalizePoiTypeForAnalytics = (type: string) => {
    if (type === PoiType.OFFERS) {
        return "investment";
    }

    return type;
};

const headingStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    userSelect: "none",
    mb: 2
});

const toggleIconStyle = css({
    display: "none",

    md: {
        display: "block",
        cursor: "pointer"
    }
});

const walkTimeRowStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 2
});

const poiTypeLabelStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1
});

const poiTypeItemStyle = css({
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2.5,

    "&:last-of-type": {
        mb: 0
    },

    md: {
        mb: 2
    }
});

const poiDistanceWrapperStyle = css({
    mt: 3
});
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {css} from "@panda/css";

import {ChevronDownIcon, ChevronUpIcon, WalkIcon} from "@pg-design/icons-module";
import {Switcher} from "@pg-design/switcher-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../app/rp_reducer";
import {setActivePoiDirections} from "../actions/set_poi_travel_directions";
import {poiAnalytics, PoiGTMModalAction} from "../tracking/poi_analytics";
import {PoiType} from "../types/PoiType";
import {SWITCHER_POI_CONFIG} from "../utils/poi_type_utils";
import {PoiSwitcherDistance} from "./PoiSwitcherDistance";

const WALK_SPEED_KM_PER_HOUR = 4;
const getWalkMinutesForDistance = (distanceKm: number) => Math.round((distanceKm / WALK_SPEED_KM_PER_HOUR) * 60);

interface IProps {
    checkedPoiTypes: PoiType[];
    onChange: (checkedPoiTypes: PoiType[]) => void;
    distanceValue?: number;
    onDistanceChange?: (value: number) => void;
    hideHeader?: boolean;
    disableCollapsible?: boolean;
    className?: string;
}

export const PoiSwitcher = (props: IProps) => {
    const dispatch = useDispatch();
    const params = useParams<{offerId?: string; propertyId?: string}>();

    const [collapsed, setCollapsed] = useState(false);

    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    const togglePoiType = (type: string, checked: boolean) => {
        /*
         * Because our current implementation of rendering markers on the map re-renders marker each time when we are
         * adding or removing records (markers) (so marker InfoWindow is being closed) we need to remove polylines from the map.
         */
        dispatch(setActivePoiDirections(null));

        props.onChange(checked ? props.checkedPoiTypes.concat(type as PoiType) : props.checkedPoiTypes.filter((item) => item !== type));

        poiAnalytics.gtm.mapEvent({
            action: checked ? PoiGTMModalAction.IMPORTANT_PLACES_ON : PoiGTMModalAction.IMPORTANT_PLACES_OFF,
            label: normalizePoiTypeForAnalytics(type)
        });
        poiAnalytics.algolytics.showPoi(viewType, checked, type as PoiType, params.offerId, params.propertyId);
    };

    return (
        <div className={props.className}>
            {props.hideHeader ? null : (
                <div className={headingStyle}>
                    <Text as="p" variant="mini_header">
                        Ważne miejsca
                    </Text>
                    {props.disableCollapsible ? null : (
                        <span className={toggleIconStyle} onClick={() => setCollapsed((prev) => !prev)}>
                            {collapsed ? <ChevronDownIcon size="2" /> : <ChevronUpIcon size="2" />}
                        </span>
                    )}
                </div>
            )}

            {(!collapsed || props.disableCollapsible) && (
                <>
                    {typeof props.distanceValue === "number" && (
                        <div className={walkTimeRowStyle}>
                            <WalkIcon size="1.6" fill="var(--colors-gray-700)" />
                            <Text variant="info_txt_2" as="p" color="var(--colors-gray-700)">
                                W promieniu {getWalkMinutesForDistance(props.distanceValue)} min pieszo
                            </Text>
                        </div>
                    )}

                    <div>
                        {SWITCHER_POI_CONFIG.map((poiType) => {
                            const checked = props.checkedPoiTypes.includes(poiType.type);
                            const Icon = poiType.icon;

                            return (
                                <div key={poiType.type} className={poiTypeItemStyle}>
                                    <div className={poiTypeLabelStyle}>
                                        <Icon size="1.6" wrapperSize="2.4" wrapperColor={poiType.color} wrapperType="circle" />
                                        <Text variant="info_txt_1" as="span">
                                            {poiType.label}
                                        </Text>
                                    </div>

                                    <Switcher
                                        id={poiType.type}
                                        checked={checked}
                                        onChange={(checked) => togglePoiType(poiType.type, checked)}
                                        labelContent=""
                                        checkedColor="var(--colors-gray-800)"
                                    />
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            {props.onDistanceChange ? (
                <div className={poiDistanceWrapperStyle}>
                    <Text variant="mini_header" mb={1} as="p">
                        Promień
                    </Text>
                    <PoiSwitcherDistance value={props.distanceValue} onChange={props.onDistanceChange} />
                </div>
            ) : null}
        </div>
    );
};

const normalizePoiTypeForAnalytics = (type: string) => {
    if (type === PoiType.OFFERS) {
        return "investment";
    }

    return type;
};

const headingStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    userSelect: "none",
    mb: 2
});

const toggleIconStyle = css({
    display: "none",

    md: {
        display: "block",
        cursor: "pointer"
    }
});

const walkTimeRowStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 2
});

const poiTypeLabelStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1
});

const poiTypeItemStyle = css({
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2.5,

    "&:last-of-type": {
        mb: 0
    },

    md: {
        mb: 2
    }
});

const poiDistanceWrapperStyle = css({
    mt: 3
});
